import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AppLauncherState {
  // Mapping of Hub ID (e.g. 'people', 'assets') to an array of Tool IDs that are pinned/favorited
  pinnedTools: Record<string, string[]>;
  togglePin: (hubId: string, toolId: string) => void;
  reorderPinned: (hubId: string, newOrder: string[]) => void;
}

export const useAppLauncherStore = create<AppLauncherState>()(
  persist(
    (set) => ({
      pinnedTools: {},
      
      togglePin: (hubId, toolId) => set((state) => {
        const hubPins = state.pinnedTools[hubId] || [];
        const isPinned = hubPins.includes(toolId);
        
        let newPins;
        if (isPinned) {
          newPins = hubPins.filter(id => id !== toolId);
        } else {
          newPins = [...hubPins, toolId];
        }
        
        return {
          pinnedTools: {
            ...state.pinnedTools,
            [hubId]: newPins
          }
        };
      }),
      
      reorderPinned: (hubId, newOrder) => set((state) => ({
        pinnedTools: {
          ...state.pinnedTools,
          [hubId]: newOrder
        }
      }))
    }),
    {
      name: 'teamone-app-launcher-storage',
    }
  )
);
